import axios from "axios"
import useToastManager from "@/composables/toastManager.js"

export function createClient(baseUrl) {
  const http = axios.create({})

  http.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      config.baseURL = baseUrl
      return config
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error)
    }
  )

  // Add a response interceptor
  http.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      useToastManager().error({ message: "An error occurred. Please try again later." })
      return Promise.reject(error.response)
    }
  )

  return http
}
